import {
  Document,
  PDFViewer,
  Page as PDFPage,
  StyleSheet,
  Text as PDFText,
  View as PDFView,
  Image as PDFImage
} from '@react-pdf/renderer';
import { dateFormatter, getCurrentDateTime } from '../../../../../utils';

const styles = StyleSheet.create({
  page: {
    padding: 20
  },
  heading: {
    fontSize: 18,
    textAlign: 'center',
    marginBottom: 20
  },
  line: {
    height: 0.6,
    backgroundColor: 'black',
    marginVertical: 10,
    marginTop: '40px'
  },
  line2: {
    height: 0.4,
    backgroundColor: 'black',
    marginVertical: 10
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 0,
    marginBottom: 0,
    border: '1px Solid black',
    padding: '10px'
  },
  contentContainer2: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 0,
    marginBottom: 0
  },
  column: {
    flex: 1,
    paddingHorizontal: 10
  },
  row: {
    flexDirection: 'row',
    marginBottom: 0
  },
  text: {
    fontSize: 9,
    display: 'inline-block'
  },
  textBold: {
    fontSize: 9,
    fontWeight: 'bold'
  },
  textUnderlined: {
    textDecoration: 'underline'
  },
  columnHeader: {
    width: '10%',
    backgroundColor: '#1976D2',
    color: 'white',
    padding: 6,
    textAlign: 'center'
  },
  columnContent: {
    width: '10%',
    padding: 6,
    textAlign: 'start',
    alignItems: 'center'
  },
  columnNumberContent: {
    width: '10%',
    padding: 6,
    textAlign: 'right',
    alignItems: 'center'
  }
});

const fullScreenStyles = {
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: 1000,
    backgroundColor: 'white'
  }
};

const COLORS = ['#ffffff', '#e0e0e0'];

const Page = ({ style, children, ...props }) => (
  <PDFPage style={{ ...styles.page, ...style }} {...props}>
    {children}
  </PDFPage>
);

const View = ({ style, children, ...props }) => (
  <PDFView style={{ ...style }} {...props}>
    {children}
  </PDFView>
);

const Text = ({ style, content, ...props }) => (
  <PDFText style={{ ...styles.text, ...style }} {...props}>
    {content}
  </PDFText>
);

export const ConsultantRevenueAnalysisReportPdf = ({ data }) => {
  console.log(data);
  const user = JSON.parse(localStorage.getItem('user'));

  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }


  return (
    <div style={fullScreenStyles.container}>
      <PDFViewer width="100%" height="100%" showToolbar>
        <Document title="Consultant Revenue Analysis Report">
          <Page style={styles.page} size="A4" orientation="landscape">
            <PDFImage
              src="/logo_Hospital_m.jpeg"
              style={{ width: '100%', height: '80px', marginBottom: 1, marginRight: '10%' }}
            />
            <View style={styles.row}>
              <Text style={{ ...styles.columnHeader, width: '70px' }} content="Sr No." />
              <Text style={{ ...styles.columnHeader,}} content="Bill Date" />
              <Text style={{ ...styles.columnHeader, width: '200px' }} content="Patient Name" />
              <Text style={{ ...styles.columnHeader, width: '100px' }} content="Uhid No." />
              <Text style={styles.columnHeader} content="Adm No" />
              <Text style={styles.columnHeader} content="Paymode" />
              <Text style={{ ...styles.columnHeader, width: '150px' }} content="Consultant" />
              <Text style={{ ...styles.columnHeader, width: '140px' }} content="Services" />
              <Text style={styles.columnHeader} content="Panel" />
              <Text style={styles.columnHeader} content="Bill Amt." />
              <Text style={styles.columnHeader} content="Dis Amt." />
              <Text style={styles.columnHeader} content="Recd Amt." />
              <Text style={styles.columnHeader} content="Bal. Amt." />
            </View>

            {data &&
              data?.opdData?.data?.map((data, index) => (
                <View key={index} style={{ ...styles.row, backgroundColor: COLORS[index % COLORS.length] }}>
                  <Text style={{ ...styles.columnContent, width: '65px', textAlign: 'center' }} content={index + 1} />
                  <Text style={{ ...styles.columnContent, width: '110px' }} content={formatDate(data?.date)} />
                  <Text style={{ ...styles.columnContent, width: '210px' }}
                        content={`${data.name_suffix} ${data.first_name} ${data.last_name}`} />
                  <Text style={styles.columnContent} content={data.uhid} />
                  <Text style={styles.columnContent} content={data.adm_no || '-'} />
                  <Text style={{ ...styles.columnContent, width: '100px' }} content={data.payment_mode} />
                  <Text style={{ ...styles.columnContent, width: '150px' }} content={data.consultant.name} />
                  <Text style={{ ...styles.columnContent, width: '100px' }} content="Consultancy" />
                  <Text style={{ ...styles.columnContent, textAlign: 'right' }} content={data.sponsor.name} />
                  <Text style={styles.columnNumberContent} content={data.reg} />
                  <Text style={styles.columnNumberContent} content={data.disc} />
                  <Text style={styles.columnNumberContent} content={data.recd} />
                  <Text style={{ ...styles.columnNumberContent, marginRight: '8px'}} content={data.bal} />
                </View>
              ))}
            <View style={{ marginLeft: '67%', marginTop: '10px', flexDirection: 'row', marginBottom: 0 }}>
              <Text style={{ ...styles.columnContent, width: '83px', fontSize: "9px", fontFamily: "Roboto", color:'red' }} content="OPD TOTAL :" />
              <Text style={{ ...styles.columnContent, width: '68px', fontSize: "8px", fontFamily: "Roboto", }} content={data?.opdData?.stats?.bill_amt} />
              <Text style={{ ...styles.columnContent, width: '38px', fontSize: "8px", fontFamily: "Roboto", }} content={data?.opdData?.stats?.disc_amt} />
              <Text style={{ ...styles.columnContent, width: '67px', fontSize: "8px", fontFamily: "Roboto", }} content={data?.opdData?.stats?.recd_amt} />
              <Text style={{ ...styles.columnContent, fontSize: "8px", fontFamily: "Roboto", }} content={data?.opdData?.stats?.bal_amt} />
            </View>
            {data &&
              data?.opdBillingData?.data?.map((data, index) => (
                <View key={index} style={{ ...styles.row, backgroundColor: COLORS[index % COLORS.length] }}>
                  <Text style={{ ...styles.columnContent, width: '65px', textAlign: 'center' }} content={index + 1} />
                  <Text style={{ ...styles.columnContent, width: '110px' }} content={formatDate(data?.date)} />
                  <Text style={{ ...styles.columnContent, width: '210px' }} 
                        content={`${data.patient.name_suffix} ${data.patient.first_name} ${data.patient.last_name}`} />
                  <Text style={styles.columnContent} content={data.uhid} />
                  <Text style={styles.columnContent} content={data.adm_no || '-'} />
                  <Text style={{ ...styles.columnContent, width: '100px' }} content={data.pay_mode} />
                  <Text style={{ ...styles.columnContent, width: '120px' }} content={data.patient.consultant.name} />
                  <Text style={{ ...styles.columnContent, width: '140px' }} content={data.combinedServiceDetails 
                  .map(({ service_name, test_name }) => service_name || test_name)
                      .join(', ')} />
                  <Text style={{ ...styles.columnContent, textAlign: 'right' }} content={data.patient.sponsor.name} />
                  <Text style={styles.columnNumberContent} content={data.total_amt} />
                  <Text style={styles.columnNumberContent} content={data.disc_amt} />
                  <Text style={styles.columnNumberContent} content={data.total_recd} />
                  <Text style={{ ...styles.columnNumberContent, marginRight: '8px'}} content={data.balance_amt} />
                </View>
              ))}

            <View style={{ marginLeft: '63%', marginTop: '10px', flexDirection: 'row', marginBottom: 0 }}>
              <Text style={{ ...styles.columnContent, width: '125px', fontSize: "9px", fontFamily: "Roboto", color:'red' }} content="OPD BILLING TOTAL :" />
              <Text style={{ ...styles.columnContent, width: '65px', fontSize: "8px", fontFamily: "Roboto", }} content={data?.opdBillingData?.stats?.bill_amt} />
              <Text style={{ ...styles.columnContent, width: '48px', fontSize: "8px", fontFamily: "Roboto", }} content={data?.opdBillingData?.stats?.disc_amt} />
              <Text style={{ ...styles.columnContent, width: '67px', fontSize: "8px", fontFamily: "Roboto", }} content={data?.opdBillingData?.stats?.recd_amt} />
              <Text style={{ ...styles.columnContent, fontSize: "8px", fontFamily: "Roboto", }} content={data?.opdBillingData?.stats?.bal_amt} />
            </View>

            {data &&
              data?.indoorServiceData?.data?.map((data, index) => (
                <View key={index} style={{ ...styles.row, backgroundColor: COLORS[index % COLORS.length] }}>
                  <Text style={{ ...styles.columnContent, width: '65px', textAlign: 'center' }} content={index + 1} />
                  <Text style={{ ...styles.columnContent, width: '110px' }} content={formatDate(data?.date)} />
                  <Text
                    style={{ ...styles.columnContent, width: '210px' }}
                    content={`${data.patient.name_suffix} ${data.patient.first_name} ${data.patient.last_name}`}
                  />
                  <Text style={styles.columnContent} content={data.patient.uhid} />
                  <Text style={styles.columnContent} content={data.ipd_no} />
                  <Text style={{ ...styles.columnContent, width: '100px' }} content={data.pay_mode} />
                  <Text style={{ ...styles.columnContent, width: '150px' }} content={data.patient.consultant.name} />
                  <Text style={{ ...styles.columnContent, width: '100px' }}
                        content={data.combinedServiceDetails.map(({ service_name, test_name }) => service_name || test_name)
                                 .join(', ')}  />
                  <Text style={{ ...styles.columnContent, textAlign: 'right' }} content={data.patient.sponsor.name} />
                  <Text style={styles.columnNumberContent} content={data.total_amt} />
                  <Text style={styles.columnNumberContent} content={data.disc_amt} />
                  <Text style={styles.columnNumberContent} content={data.total_recd} />
                  <Text style={{ ...styles.columnNumberContent, marginRight: '8px'}} content={data.balance_amt} />
                </View>
              ))}

            <View style={{ marginLeft: '63%', marginTop: '10px', flexDirection: 'row', marginBottom: 0 }}>
              <Text style={{ ...styles.columnContent, width: '110px', fontSize: "9px", fontFamily: "Roboto", color:'red' }} content="IPD BILLING TOTAL : " />
              <Text style={{ ...styles.columnContent, width: '58px', fontSize: "8px", fontFamily: "Roboto", }} content={data?.indoorServiceData?.stats?.bill_amt} />
              <Text style={{ ...styles.columnContent, width: '47px', fontSize: "8px", fontFamily: "Roboto", }} content={data?.indoorServiceData?.stats?.disc_amt} />
              <Text style={{ ...styles.columnContent, width: '50px', fontSize: "8px", fontFamily: "Roboto", }} content={data?.indoorServiceData?.stats?.recd_amt} />
              <Text style={{ ...styles.columnContent, fontSize: "8px", fontFamily: "Roboto", }} content={data?.indoorServiceData?.stats?.bal_amt} />
            </View>
          </Page>
        </Document>
      </PDFViewer>
    </div>
  );
};

export default ConsultantRevenueAnalysisReportPdf;
